export const formatPrice = (price, currency = 'CZK', locale = 'cs-CZ') => {
  if (price === null || price === undefined) return 'N/A';

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(price);
};

/**
 * Format a price-per-unit value (e.g. { amount: 39.8, unit: '100 g' }) as a
 * localized string like "39,80 Kč / 100 g". Uses 2 fraction digits because
 * per-unit amounts are small. Returns null when there is nothing to show, so
 * callers can simply skip rendering.
 *
 * @param {{amount:number, unit:string}|null|undefined} pricePerUnit
 * @param {string} [currency='CZK']
 * @param {string} [locale='cs-CZ']
 * @returns {string|null}
 */
export const formatPricePerUnit = (pricePerUnit, currency = 'CZK', locale = 'cs-CZ') => {
  if (!pricePerUnit || pricePerUnit.amount == null || pricePerUnit.amount === '') return null;

  const formatted = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(pricePerUnit.amount);

  return `${formatted} / ${pricePerUnit.unit}`;
};

export const formatDate = (date, locale = 'en-US') => {
  if (!date) return '';

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  }).format(new Date(date));
};

export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
